export default (el) => el.textContent;
